export default [
    { path: '/monitor', component: require('./components/Dashboard.vue').default },
    { path: '/profile', component: require('./components/Profile.vue').default },
    { path: '/developer', component: require('./components/Developer.vue').default },
    { path: '/users', component: require('./components/Users.vue').default },
    { path: '/markers', component: require('./components/marker/Markers.vue').default },
    { path: '/markers/categories', component: require('./components/marker/MarkerCategories.vue').default },
    { path: '/feeds', component: require('./components/feed/Feeds.vue').default },
    { path: '/socialTimelines', component: require('./components/socialtimeline/SocialTimelines.vue').default },
    { path: '/socialSearchers', component: require('./components/socialsearcher/SocialSearcher.vue').default },
    { path: '/chamberSearches', component: require('./components/chambersearch/ChamberSearch.vue').default },
    { path: '/users/subscription/:user_id', component: require('./components/UserSubscription.vue').default },
    { path: '/users/monitor/:user_id', component: require('./components/UserMonitor.vue').default },
    { path: '/contact', component: require('./components/Contact.vue').default },
    { path: '/support', component: require('./components/Support.vue').default },
    { path: '/waMessager', component: require('./components/WhatsAppMessager.vue').default },
    { path: '*', component: require('./components/NotFound.vue').default }
];
